export const ZONE_IDS_PTL = {
	PROG_BANNER: '962515',
	HOUSE_BANNER: '962516',
	PROG_HOMEPAGE_BANNER: '962517',
	HOUSE_LONG_CARD: '962518',
	PROG_LONG_CARD: '962519'
} as const;
